import { connect } from 'react-redux';
import { isSubmitting, formValueSelector } from 'redux-form';
import Component from './Component';

import componentDidMount from './Handlers/componentDidMount';
import onClickCancel from './Handlers/onClickCancel';
import onClickSubmit from './Handlers/onClickSubmit';
import onClickDelete from './Handlers/onClickDelete';

import { FORM_NAME } from './Form';

const mapStateToProps = (state) => ({
  submitting: isSubmitting(FORM_NAME)(state),
  preferredSupplier: formValueSelector(FORM_NAME)(state, 'preferred_supplier'),
  clientRiskLevels: state.core.clientRiskLevels,
  users: state.core.users,
});

const actionCreators = {
  componentDidMount,
  onClickCancel,
  onClickSubmit,
  onClickDelete,
};

export default connect(mapStateToProps, actionCreators)(Component);
